import { DateTime } from 'luxon'

import TruncateLines from '@components/TruncateLines'
import { Typography } from '@mui/material'

import { CellInfo } from '../types'

export const LastEventCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
  } = info

  if (!profileData.profileEvents || profileData.profileEvents.length === 0) {
    return null
  }
  const now = DateTime.now()
  const pastEvents = profileData.profileEvents.filter(
    event => DateTime.fromISO(event.endDate).startOf('day') < now.startOf('day'),
  )

  const sortedEvents = pastEvents.sort((a, b) => DateTime.fromISO(b.endDate).valueOf() - DateTime.fromISO(a.endDate).valueOf())
  const lastEvent = sortedEvents[0]

  if (!lastEvent) return null

  return (
    <TruncateLines lines={5}>
      <Typography style={{ fontWeight: 700 }}>{lastEvent.name}</Typography>
    </TruncateLines>
  )
}
